import * as TabsPrimitive from "@radix-ui/react-tabs";
import { PropsWithChildren } from "react";

type Props = PropsWithChildren & { value: string };

/**
 * タブの内容コンポーネント
 * @param props props
 * @returns タブの内容コンポーネント
 */
export default function TabsContent(props: Props) {
	const { value, children } = props;

	return (
		<TabsPrimitive.Content value={value}>{children}</TabsPrimitive.Content>
	);
}
